import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const isVehicleSeniorityInheritedSelector = selector<boolean>({
    key: 'isVehicleSeniorityInheritedSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const isLoggedOn = get(isLoggedOnSelector);

        if (!isLoggedOn || currentProduct.flavourName !== 'Bilforsikring') {
            return false;
        }

        const seniorityReason = await OnlineSales.getVehicleSeniorityReason(
            jobNumber,
            sessionId,
            currentProduct.fixedId
        );

        return (
            seniorityReason === 'ExtraVehicle' ||
            seniorityReason === 'SeniorityFromPreviousInsurance'
        );
    }
});
